// extracted by mini-css-extract-plugin
export default {"content":"EditModal_content__Ohwba"};